import { useRef, useEffect, useState } from 'react'

import Styles from './EmojiInput.module.scss'
import { Emoji } from 'node-emoji'

interface Props {
  results: Emoji[]
  onEmojiSelect: (emoji: string) => void
}

const EmojiInputView = ({ results, onEmojiSelect }: Props) => {
  const [selected, _setSelected] = useState<number>()

  const selectedRef = useRef(selected)

  const setSelected = (data?: number) => {
    selectedRef.current = data
    _setSelected(data)
  }

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const { current } = selectedRef
      if (e.key === 'ArrowUp') {
        if (results.length) e.preventDefault()
        if (!current) {
          setSelected(results.length - 1)
        } else {
          setSelected(current - 1)
        }
      }
      if (e.key === 'ArrowDown') {
        if (results.length) e.preventDefault()
        if (current === undefined || current === results.length - 1) {
          setSelected(0)
        } else {
          setSelected(current + 1)
        }
      }
      if (e.key === 'Enter') {
        if (results.length) e.preventDefault()
        if (selected !== undefined) {
          onEmojiSelect(results[selected].emoji)
        }
      }
    }

    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
    }
  }, [results, selected, onEmojiSelect])

  useEffect(() => {
    if (!results.length) {
      setSelected(undefined)
      return
    }

    if (!selected || selected >= results.length) {
      setSelected(0)
    }
  }, [results, selected])

  const renderEmojiRow = (emoji: Emoji, index: number) => {
    return (
      <div
        key={emoji.key}
        className={selected === index ? Styles.emojiRow__selected : Styles.emojiRow}
        onMouseEnter={() => setSelected(index)}
        onClick={() => onEmojiSelect(emoji.emoji)}
      >
        <div className={Styles.emojiContainer}>{emoji.emoji}</div>
        <div>"{emoji.key}"</div>
      </div>
    )
  }

  return <div className={Styles.viewContainer}>{results.map(renderEmojiRow)}</div>
}

export default EmojiInputView
